import { ExternalAccount } from '@/src/common/components/fundingSourceSelector'
import { MortgageAddress } from '@api/mesa/graphql'
import { create } from 'zustand'

export const useCashForMortgageStore = create<{
  pointsToRedeem: string | undefined
  setPointsToRedeem: (points: string | undefined) => void
  remainingPoints: string | undefined
  setRemainingPoints: (points: string | undefined) => void
  creditAmount: string | undefined
  setCreditAmount: (amount: string | undefined) => void
  conversionRate: string | undefined
  setConversionRate: (rate: string | undefined) => void
  destinationAccount: Partial<ExternalAccount> | undefined
  setDestinationAccount: (account: Partial<ExternalAccount>) => void
  idempotencyKey: string | undefined
  setIdempotencyKey: (key: string | undefined) => void
  mortgageAddress: MortgageAddress | undefined
  setMortgageAddress: (address: MortgageAddress) => void
  clear: () => void
}>((set) => ({
  pointsToRedeem: undefined,
  setPointsToRedeem: (points) => set({ pointsToRedeem: points }),
  remainingPoints: undefined,
  setRemainingPoints: (points) => set({ remainingPoints: points }),
  creditAmount: undefined,
  setCreditAmount: (amount) => set({ creditAmount: amount }),
  conversionRate: undefined,
  setConversionRate: (rate) => set({ conversionRate: rate }),
  destinationAccount: undefined,
  setDestinationAccount: (account) => set({ destinationAccount: account }),
  idempotencyKey: undefined,
  setIdempotencyKey: (key) => set({ idempotencyKey: key }),
  mortgageAddress: undefined,
  setMortgageAddress: (address) => set({ mortgageAddress: address }),
  clear: () =>
    set({
      pointsToRedeem: undefined,
      remainingPoints: undefined,
      creditAmount: undefined,
      conversionRate: undefined,
      destinationAccount: undefined,
      mortgageAddress: undefined,
    }),
}))
